import { Suspense } from "react";
import { Route, Routes } from "react-router";
import { EtlHomeRouter } from "./router";
import { PageContainer } from "etl/design-system/organisms/PageContainer";
import { FallBackSpinner } from "etl/design-system/molecules/FallBackSpinner";

export const EtlHome = () => {
	return (
		<Suspense fallback={<FallBackSpinner />}>
			<PageContainer>
				<Routes>
					{EtlHomeRouter.map((route) =>
						<Route key={route.path} path={route.path} element={route.component} />
					)}
				</Routes>
			</PageContainer>
		</Suspense>
	)
};
